// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';

interface Props {
  formValues: any;
  showMap: () => void;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

/**
 * Function to create a React Component component
 *
 * @param props component properties
 * @returns react node component
 */
function Form(props: Props): JSX.Element {
  const { data } = props.formValues;

  return (
    <fieldset>
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Code</b> &nbsp;
          </label>
          <input
            className="inputNew"
            style={{ width: '80%' }}
            type="text"
            value={data.code || ''}
            name="code"
            onChange={props.onChange}
            required
          />
          <label>&nbsp;&nbsp;*</label>
        </div>
        <div className="col-6">
          <label className="label">
            <b>Name</b> &nbsp;
          </label>
          <input
            className="inputNew"
            style={{ width: '80%' }}
            type="text"
            value={data.name || ''}
            name="name"
            onChange={props.onChange}
            required
          />
          <label>&nbsp;&nbsp;*</label>
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Address</b> &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;
          </label>
          <input
            className="inputNew"
            style={{ width: '80%' }}
            type="text"
            value={data.address || ''}
            name="address"
            id="address"
            onChange={props.onChange}
          />
          <label>&nbsp;&nbsp;</label>
        </div>
        <div className="col-2">
          <label className="label">
            <b>Latitude:</b>
          </label>
          <input
            className="inputNew"
            style={{ width: '80%' }}
            type="number"
            value={data?.latitude || 0}
            name="latitude"
            step="any"
            onChange={props.onChange}
            required
          />
          <label>&nbsp;&nbsp;*</label>
        </div>
        <div className="col-2">
          <label className="label">
            <b>Longitude:</b>
          </label>
          <input
            className="inputNew"
            style={{ width: '80%' }}
            type="number"
            value={data?.longitude || 0}
            name="longitude"
            step="any"
            onChange={props.onChange}
            required
          />
          <label>&nbsp;&nbsp;*</label>
        </div>
        <div className="col-2">
          <label className="label">&nbsp;</label>
          <button
            type="button"
            onClick={props.showMap}
            className="btn btn-secondary"
            style={{ margin: '0px 0 0 5px', padding: '0 22px', height: '31px' }}
          >
            Map
          </button>
        </div>
      </div>
    </fieldset>
  );
}

export default Form;
